var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import { Box, styled } from "@mui/material";
var fontStyles = "\n  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;700&family=Inter:wght@300;400;500;700&family=Open+Sans:wght@300;400;500;700&family=Lato:wght@300;400;500;700&family=Montserrat:wght@300;400;500;700&family=Poppins:wght@300;400;500;700&display=swap');\n\n  /* Dropdown labels */\n  .ql-snow .ql-picker.ql-font .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Inter';\n    font-family: 'Inter', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"inter\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"inter\"]::before {\n    content: 'Inter';\n    font-family: 'Inter', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"nunito\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"nunito\"]::before {\n    content: 'Nunito';\n    font-family: 'Nunito', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"opensans\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"opensans\"]::before {\n    content: 'Open Sans';\n    font-family: 'Open Sans', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"lato\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"lato\"]::before {\n    content: 'Lato';\n    font-family: 'Lato', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"montserrat\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"montserrat\"]::before {\n    content: 'Montserrat';\n    font-family: 'Montserrat', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"poppins\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"poppins\"]::before {\n    content: 'Poppins';\n    font-family: 'Poppins', sans-serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"serif\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"serif\"]::before {\n    content: 'Serif';\n    font-family: Georgia, 'Times New Roman', serif;\n  }\n\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=\"monospace\"]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=\"monospace\"]::before {\n    content: 'Monospace';\n    font-family: Monaco, 'Courier New', monospace;\n  }\n\n  /* Ensure fonts are available everywhere */\n  * {\n    --ql-font-inter: 'Inter', sans-serif;\n    --ql-font-nunito: 'Nunito', sans-serif;\n    --ql-font-opensans: 'Open Sans', sans-serif;\n    --ql-font-lato: 'Lato', sans-serif;\n    --ql-font-montserrat: 'Montserrat', sans-serif;\n    --ql-font-poppins: 'Poppins', sans-serif;\n  }\n";
var QuillWrapper = styled(Box)({
    position: "relative",
    "& .ql-toolbar.ql-snow": {
        position: "sticky",
        top: 0,
        zIndex: 10,
        background: "#fff",
        borderBottom: "1px solid #ccc",
    },
    "& .ql-container.ql-snow": {
        height: "250px",
    },
    "& .ql-editor": {
        minHeight: "250px",
        fontFamily: "inherit !important",
    },
    "& .ql-editor span.ql-font-inter": {
        fontFamily: "'Inter', sans-serif !important",
    },
    "& .ql-editor span.ql-font-nunito": {
        fontFamily: "'Nunito', sans-serif !important",
    },
    "& .ql-editor span.ql-font-opensans": {
        fontFamily: "'Open Sans', sans-serif !important",
    },
    "& .ql-editor span.ql-font-lato": {
        fontFamily: "'Lato', sans-serif !important",
    },
    "& .ql-editor span.ql-font-montserrat": {
        fontFamily: "'Montserrat', sans-serif !important",
    },
    "& .ql-editor span.ql-font-poppins": {
        fontFamily: "'Poppins', sans-serif !important",
    },
    "& .ql-editor span.ql-font-serif": {
        fontFamily: "Georgia, 'Times New Roman', serif !important",
    },
    "& .ql-editor span.ql-font-monospace": {
        fontFamily: "Monaco, 'Courier New', monospace !important",
    },
    "& .ql-editor p.ql-font-inter, & .ql-editor div.ql-font-inter": {
        fontFamily: "'Inter', sans-serif !important",
    },
    "& .ql-editor p.ql-font-nunito, & .ql-editor div.ql-font-nunito": {
        fontFamily: "'Nunito', sans-serif !important",
    },
    "& .ql-editor p.ql-font-opensans, & .ql-editor div.ql-font-opensans": {
        fontFamily: "'Open Sans', sans-serif !important",
    },
    "& .ql-editor p.ql-font-lato, & .ql-editor div.ql-font-lato": {
        fontFamily: "'Lato', sans-serif !important",
    },
    "& .ql-editor p.ql-font-montserrat, & .ql-editor div.ql-font-montserrat": {
        fontFamily: "'Montserrat', sans-serif !important",
    },
    "& .ql-editor p.ql-font-poppins, & .ql-editor div.ql-font-poppins": {
        fontFamily: "'Poppins', sans-serif !important",
    },
    "& .ql-editor * .ql-font-inter": {
        fontFamily: "'Inter', sans-serif !important",
    },
    "& .ql-editor * .ql-font-nunito": {
        fontFamily: "'Nunito', sans-serif !important",
    },
    "& .ql-editor * .ql-font-opensans": {
        fontFamily: "'Open Sans', sans-serif !important",
    },
    "& .ql-editor * .ql-font-lato": {
        fontFamily: "'Lato', sans-serif !important",
    },
    "& .ql-editor * .ql-font-montserrat": {
        fontFamily: "'Montserrat', sans-serif !important",
    },
    "& .ql-editor * .ql-font-poppins": {
        fontFamily: "'Poppins', sans-serif !important",
    },
});
var Font = Quill.import("formats/font");
Font.whitelist = ["inter", "nunito", "opensans", "lato", "montserrat", "poppins", "serif", "monospace"];
Quill.register(Font, true);
var toolbarOptions = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: ["inter", "nunito", "opensans", "lato", "montserrat", "poppins", "serif", "monospace"] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
];
var RichTextEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, maxLength = _a.maxLength;
    var wrapperRef = useRef(null);
    var editorContainerRef = useRef(null);
    var quillRef = useRef(null);
    var isInternalChange = useRef(false);
    useEffect(function () {
        if (!document.getElementById("quill-font-style")) {
            var style = document.createElement("style");
            style.id = "quill-font-style";
            style.innerHTML = fontStyles;
            document.head.appendChild(style);
        }
    }, []);
    useEffect(function () {
        if (!editorContainerRef.current || quillRef.current)
            return;
        var Clipboard = Quill.import("modules/clipboard");
        var CustomClipboard = (function (_super) {
            __extends(CustomClipboard, _super);
            function CustomClipboard() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CustomClipboard.prototype.convert = function (html) {
                var processedHtml = html;
                processedHtml = processedHtml.replace(/<ol(?![^>]*type=["']1["'])([^>]*)>/gi, function (match, attrs) {
                    if (attrs.includes('style') && attrs.includes('list-style-type') && attrs.includes('disc')) {
                        return "<ul".concat(attrs, ">");
                    }
                    return match;
                });
                return _super.prototype.convert.call(this, processedHtml);
            };
            return CustomClipboard;
        }(Clipboard));
        quillRef.current = new Quill(editorContainerRef.current, {
            theme: "snow",
            modules: {
                toolbar: toolbarOptions,
                clipboard: {}
            },
        });
        if (value) {
            var processedValue = value;
            var fontMatch = processedValue.match(/ql-font-(inter|nunito|opensans|lato|montserrat|poppins|serif|monospace)/);
            var detectedFont_1 = fontMatch ? fontMatch[1] : null;
            quillRef.current.clipboard.dangerouslyPasteHTML(processedValue);
            if (detectedFont_1) {
                setTimeout(function () {
                    var length = quillRef.current.getLength();
                    if (length > 1) {
                        quillRef.current.formatText(0, length - 1, "font", detectedFont_1);
                    }
                }, 10);
            }
        }
        quillRef.current.on("text-change", function (_delta, _oldDelta, source) {
            if (source === "silent")
                return;
            isInternalChange.current = true;
            var quill = quillRef.current;
            var selection = quill.getSelection();
            if (selection && source === "user") {
                var formats = quill.getFormat(selection.index - 1, 1);
                if (formats.font) {
                    quill.format("font", formats.font);
                }
            }
            var textLength = quill.getText().replace(/\n/g, "").length;
            if (maxLength && textLength > maxLength) {
                var excess = textLength - maxLength;
                var endIndex = quill.getLength() - 1;
                quill.deleteText(endIndex - excess, excess);
            }
            var html = quill.root.innerHTML;
            onChange === null || onChange === void 0 ? void 0 : onChange(html);
            setTimeout(function () {
                isInternalChange.current = false;
            }, 0);
        });
        quillRef.current.on("selection-change", function (range) {
            if (!range)
                return;
            var formats = quillRef.current.getFormat();
            quillRef.current.currentFormats = formats;
        });
    }, []);
    useEffect(function () {
        if (!quillRef.current || value === undefined)
            return;
        if (isInternalChange.current)
            return;
        var selection = quillRef.current.getSelection();
        var processedValue = value;
        if (quillRef.current.root.innerHTML !== processedValue) {
            quillRef.current.clipboard.dangerouslyPasteHTML(processedValue);
            var fontMatch = processedValue.match(/ql-font-(inter|nunito|opensans|lato|montserrat|poppins|serif|monospace)/);
            if (fontMatch && fontMatch[1]) {
                var font = fontMatch[1];
                var length_1 = quillRef.current.getLength();
                if (length_1 > 1) {
                    quillRef.current.formatText(0, length_1 - 1, "font", font);
                }
            }
            if (selection) {
                requestAnimationFrame(function () {
                    if (quillRef.current && selection) {
                        try {
                            quillRef.current.setSelection(selection);
                        }
                        catch (e) {
                        }
                    }
                });
            }
        }
    }, [value]);
    return (React.createElement(QuillWrapper, { ref: wrapperRef },
        React.createElement("div", { ref: editorContainerRef })));
};
export default RichTextEditor;
